import { makeAutoObservable } from "mobx";

import { Device } from "./BreakpointStore";

export class SidebarStore {
  private collapsed: boolean = false;
  private overlaySidebarVisible: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  public get isOverlaySidebarVisible() {
    return this.overlaySidebarVisible;
  }

  public setOverlaySidebarVisible = (visible: boolean) => {
    this.overlaySidebarVisible = visible;
  };

  public get isCollapsed() {
    return this.collapsed;
  }

  public isOverlaySidebar = (device: Device): boolean => {
    return device === Device.Mobile || device === Device.Tablet;
  };

  public toggleCollapsed = () => {
    this.collapsed = !this.collapsed;
  };
}
